import { updateGA, updateGTM } from '../utils/analytics'

export default class {
  constructor () {
    this.mode = document.body.getAttribute('data-analytics');
    this.gaMeasurementId = document.body.getAttribute('data-analytics-id')
  }

  update() {
    if (this.mode == 'gtag') {
      updateGA(this.gaMeasurementId)
    } 
    else if (this.mode == 'gtm') {
      updateGTM()
    }
  }

}
